<template>
  <h3 class="text-base text-headline font-semibold text-left truncate">
    <slot></slot>
  </h3>
</template>
